module.exports = __webpack_public_path__ + "img/hunting_stand.9e43936a.svg";